import { Star } from "lucide-react";
import { REVIEWS } from "@/data/siteData";
import { HOME } from "@/constants/testIds";

export default function Testimonials() {
  return (
    <section className="relative py-24 md:py-32 bg-[#EEF5F9] overflow-hidden">
      <div className="grain" aria-hidden />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <p className="overline">Recensioni</p>
          <h2 className="font-serif text-4xl md:text-5xl mt-4 text-[#0B4A5A] tracking-tight">
            La fiducia dei pazienti è il risultato più importante.
          </h2>
          <p className="mt-6 text-gray-600 leading-relaxed">
            Oltre 75 recensioni a 5 stelle raccolte dai pazienti.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-5">
          {REVIEWS.map((r, i) => (
            <blockquote
              key={i}
              data-testid={HOME.reviewCard(i)}
              className="bg-white rounded-2xl p-8 md:p-10 border border-gray-100 hover:border-[#C6A86B]/30 transition-all duration-500 hover:shadow-[0_10px_40px_rgba(11,74,90,0.06)]"
            >
              <div className="flex gap-0.5 mb-5">
                {[0, 1, 2, 3, 4].map((k) => (
                  <Star key={k} size={16} className="star-gold" />
                ))}
              </div>
              <p className="font-serif text-xl md:text-2xl leading-[1.35] text-[#0B4A5A]">
                “{r.text}”
              </p>
              <footer className="mt-6 text-sm text-gray-500">
                <span className="text-gray-800 font-medium">{r.author}</span>
                <span className="mx-2">·</span>
                {r.city}
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
